import * as React from "react"
import { SvgFilterFunnel02 } from "@digits-shared/components/SVGIcons/line/FilterFunnel02.svg"
import { SvgSwitchVertical01 } from "@digits-shared/components/SVGIcons/line/SwitchVertical01.svg"
import { SvgFilterFunnel02Solid } from "@digits-shared/components/SVGIcons/solid/FilterFunnel02Solid.svg"
import { BrowserFilters } from "src/frontend/components/OS/Applications/Shared/Transactions/Browser/Filters/BrowserFilters"
import { useTransactionListContext } from "src/frontend/components/OS/Applications/Shared/Transactions/TransactionListContext"
import { useSortDimensions } from "src/frontend/components/OS/Shared/DisplayOptions/displayOptionsHooks"
import { DisplayOptionsSection } from "src/frontend/components/OS/Shared/DisplayOptions/DisplayOptionsSection"
import { FilterColumn } from "src/frontend/components/OS/Shared/DisplayOptions/Filters/FilterColumn"
import { SortColumn } from "src/frontend/components/OS/Shared/DisplayOptions/Sorts/SortColumn"
import { useTransactionsDisplayOptions } from "src/frontend/components/OS/Shared/DisplayOptions/TransactionsDisplayOptionsContext"

export const BrowserDisplayOptions: React.FC = () => {
  const dimensions = useSortDimensions()
  const {
    requestVariables: {
      filter: { categoryTypes },
    },
  } = useTransactionListContext()

  const {
    currentFilterURLKeysCount,
    clearOnlyFilters,
    sortDirection,
    categoryId,
    partyId,
    missingParty,
    minValue,
    maxValue,
  } = useTransactionsDisplayOptions()

  return (
    <>
      <DisplayOptionsSection
        title="Filter"
        activeCount={currentFilterURLKeysCount}
        IconElement={SvgFilterFunnel02}
        ActiveIconElement={SvgFilterFunnel02Solid}
      >
        <FilterColumn
          onResetClick={clearOnlyFilters}
          currentFiltersCount={currentFilterURLKeysCount}
        >
          <BrowserFilters
            categoryTypes={categoryTypes}
            categoryId={categoryId}
            partyId={partyId}
            missingParty={missingParty}
            minValue={minValue}
            maxValue={maxValue}
          />
        </FilterColumn>
      </DisplayOptionsSection>

      <DisplayOptionsSection title="Sort" IconElement={SvgSwitchVertical01}>
        <SortColumn dimensions={dimensions} sortDirection={sortDirection} />
      </DisplayOptionsSection>
    </>
  )
}
